<template>
  <v-toolbar :dense="dense" :dark="dark" :class="['app-controls', fixed ? 'app-controls-fixed' : null, fixed ? 'app-controls-fixed-' + fixed : null]">
    <v-btn aria-label="color" :title="$lang.setColorScheme(color)" icon @click="setColorScheme(color)" :class="['ma-0', $root.config.colorScheme === color ? 'pointer-events-none' : null]" :key="index" v-for="(color, index) in Object.keys(colorSchemes)">
      <v-icon :color="color">{{ setColorSchemeIcon(color) }}</v-icon>
    </v-btn>
    <v-spacer />
    <v-btn aria-label="theme" :class="['ma-0']" icon @click="setTheme" :title="$lang.setTheme($root.config.dark)">
      <v-icon :color="$root.config.colorScheme">{{ $root.config.dark ? 'mdi-brightness-4' : 'mdi-brightness-7' }}</v-icon>
    </v-btn>
  </v-toolbar>
</template>
<script>
import colorSchemes from '../helpers/color-schemes'

export default {
  name: 'AppControls',
  data () {
    return {
      colorSchemes
    }
  },
  props: {
    /**
     * @boolean dense
     */
    dense: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * @boolean dark
     */
    dark: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * @boolean dense
     */
    fixed: {
      type: String,
      required: false,
      default: null
    }
  },
  methods: {
    /**
     * Set dark or light theme and store locally
     * @method setTheme
     * @return {void}
     */
    setTheme () {
      this.$root.config.dark = !this.$root.config.dark
      localStorage.setItem('dark', this.$root.config.dark)
    },
    /**
     * Set color scheme and store locally
     * @method setColorScheme
     * @param {string} color [color=config.defaultColorScheme]
     * @return {void}
     */
    setColorScheme (color = this.$root.config.defaultColorScheme) {
      this.$root.config.colorScheme = color
      localStorage.setItem('scheme', color)
    },
    /**
     * Set color scheme icon
     * @method setColorSchemeIcon
     * @param {string} color [color=config.defaultColorScheme]
     * @return {string}
     */
    setColorSchemeIcon (color = this.$root.config.defaultColorScheme) {
      return this.$root.config.colorScheme === color ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank'
    }
  }
}
</script>
<style>
.app-controls.app-controls-fixed-bottom-left,
.app-controls.app-controls-fixed-bottom-right
{
  bottom: 0;
}

.app-controls.app-controls-fixed-top-left,
.app-controls.app-controls-fixed-bottom-left
{
  left: 0;
}

.app-controls.app-controls-fixed-top-right,
.app-controls.app-controls-fixed-bottom-right
{
  right: 0;
}

.app-controls.app-controls-fixed-top-left,
.app-controls.app-controls-fixed-top-right
{
  top: 0;
}

.app-controls .v-toolbar__content
{
  padding: .5em;
}

.app-controls.app-controls-fixed
{
  position: fixed;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/app-controls.vue